import Cookies from 'js-cookie';

function initLanguages() {
  const wrap = document.querySelector('.js-languages');

  if (!wrap) return;

  const domain = wrap.getAttribute('data-domain');

  wrap.addEventListener('click', (e) => {
    const link = e.target.closest('a');

    if (!link) return;

    e.preventDefault();

    Cookies.set('lang-domain', link.getAttribute('data-lang'), {expires: 365, domain: domain});

    document.location.href = link.href;
  });
}

export {initLanguages};
